import app from 'flarum/forum/app';
import IndexPage from './Extend/IndexPage';

app.initializers.add('blomstra-flarum', () => {
  IndexPage();
});
